import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { alpha, type Theme } from '@mui/material/styles';

interface TriStateLabels {
    accept: string;
    refuse: string;
    noPreference: string;
}

interface TriStateToggleProps {
    value: string | null;
    noPreferenceValue: string;
    labels: TriStateLabels;
    onChange: (value: string | null) => void;
}

const ACCEPT_VALUE = '1';
const REFUSE_VALUE = '0';

const buttonSx = (color: 'success' | 'error' | 'primary') => ({
    cursor: 'pointer',
    '&:hover': { bgcolor: (t: Theme) => alpha(t.palette[color].main, 0.12) },
    '&.Mui-selected': { bgcolor: `${color}.main`, color: 'common.white', '&:hover': { bgcolor: `${color}.dark` } },
});

const ACCEPT_BUTTON_SX = buttonSx('success');
const REFUSE_BUTTON_SX = buttonSx('error');
const NO_PREFERENCE_BUTTON_SX = buttonSx('primary');

function TriStateToggle({ value, noPreferenceValue, labels, onChange }: TriStateToggleProps) {
    return (
        <ToggleButtonGroup size="small" exclusive value={value} onChange={(_event, next: string | null) => onChange(next)}>
            <ToggleButton value={ACCEPT_VALUE} sx={ACCEPT_BUTTON_SX}>{labels.accept}</ToggleButton>
            <ToggleButton value={REFUSE_VALUE} sx={REFUSE_BUTTON_SX}>{labels.refuse}</ToggleButton>
            <ToggleButton value={noPreferenceValue} sx={NO_PREFERENCE_BUTTON_SX}>{labels.noPreference}</ToggleButton>
        </ToggleButtonGroup>
    );
}

export default TriStateToggle;
